function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Row, Container, Col, Table } from 'react-bootstrap';
import { Skeleton, message, Button, Modal, Tabs, Drawer, Descriptions, Statistic, notification, Space } from 'antd';
import NewCustomer from "../components/forms/NewCustomer";
import { Input } from 'antd';
import moment from "moment";
import Common from "../components/includes/Common";
import { PrinterFill, FileCheckFill, XSquareFill, PersonPlusFill, ClockHistory, PencilFill } from 'react-bootstrap-icons';
import ExecOrder from "../components/forms/ExecOrder";
import PatientView from "../components/PatientView";
import EditCandidate from "../components/forms/EditCandidate";
import Moment from "react-moment";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Search = Input.Search;

var Cashier = function Cashier() {
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      selectedCustomer = _useState2[0],
      setSelectedCustomer = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      dataChanged = _useState4[0],
      setDataChanged = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      isDataLoading = _useState6[0],
      setIsDataLoading = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      customers = _useState8[0],
      setCustomers = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      execDrawerVisible = _useState10[0],
      setExecDrawerVisible = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      newCustomerCreated = _useState12[0],
      setNewCustomerCreated = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      isPatientModalOpen = _useState14[0],
      setIsPatientModalOpen = _useState14[1];

  var _useState15 = useState(null),
      _useState16 = _slicedToArray(_useState15, 2),
      searchId = _useState16[0],
      setSearchId = _useState16[1];

  var _useState17 = useState(0),
      _useState18 = _slicedToArray(_useState17, 2),
      totalCash = _useState18[0],
      setTotalCash = _useState18[1];

  var _useState19 = useState(false),
      _useState20 = _slicedToArray(_useState19, 2),
      showEdit = _useState20[0],
      setShowEdit = _useState20[1];

  var _useState21 = useState(null),
      _useState22 = _slicedToArray(_useState21, 2),
      currentCustomer = _useState22[0],
      setCurrentCustomer = _useState22[1];

  var _useState23 = useState(moment().startOf('month').format()),
      _useState24 = _slicedToArray(_useState23, 2),
      globalFrom = _useState24[0],
      setGlobalFrom = _useState24[1];

  var _useState25 = useState(moment().endOf('month').format()),
      _useState26 = _slicedToArray(_useState25, 2),
      globalTo = _useState26[0],
      setGlobalTo = _useState26[1];

  var _useState27 = useState(null),
      _useState28 = _slicedToArray(_useState27, 2),
      keyStats = _useState28[0],
      setKeyStats = _useState28[1];

  var handleUpdate = function handleUpdate() {
    setNewCustomerCreated(true);
    setDataChanged(true);
  };

  var items = [{
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(PersonPlusFill, {
        size: 24
      }), " NOUVEAU CANDIDAT"]
    }),
    key: 1,
    children: /*#__PURE__*/_jsx("div", {
      className: "white-txt cool-radius",
      style: {
        background: "#FAB918"
      },
      children: /*#__PURE__*/_jsx(NewCustomer, {
        handleUpdate: handleUpdate
      })
    })
  }, {
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(ClockHistory, {
        size: 24
      }), " HISTORIQUE"]
    }),
    key: 2,
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsxs(Table, {
        striped: true,
        responsive: true,
        bordered: true,
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("td", {
              children: /*#__PURE__*/_jsx("b", {
                children: "Date"
              })
            }), /*#__PURE__*/_jsx("td", {
              children: /*#__PURE__*/_jsx("b", {
                children: "Ref"
              })
            }), /*#__PURE__*/_jsx("td", {
              children: /*#__PURE__*/_jsx("b", {
                children: "Nom"
              })
            }), /*#__PURE__*/_jsx("td", {
              children: /*#__PURE__*/_jsx("b", {
                children: "Societe"
              })
            }), /*#__PURE__*/_jsx("td", {
              children: /*#__PURE__*/_jsx("b", {
                children: "Action"
              })
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: customers.map(function (c) {
            return /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx(Moment, {
                  date: c.created_at,
                  format: "DD/MM/YYYY"
                })
              }), /*#__PURE__*/_jsx("td", {
                children: c.candidate_code
              }), /*#__PURE__*/_jsx("td", {
                children: c.name
              }), /*#__PURE__*/_jsx("td", {
                children: c.company.label
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx(Space, {
                  direction: "horizontal",
                  children: /*#__PURE__*/_jsx(Button, {
                    type: "link",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowEdit(true);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: /*#__PURE__*/_jsx(PencilFill, {
                        size: 24
                      })
                    })
                  })
                })
              })]
            }, c.id);
          })
        })]
      })
    })
  }];
  useEffect(function () {
    setIsDataLoading(true);
    setDataChanged(false);
    axios.all([axios.get(Common.baseApiUrl + 'getcurrentdaycustomers/' + Common.currentUser.id.toString())]).then(function (response) {
      if (response[0].data.status == 200) {
        setCustomers(response[0].data.customers);
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [newCustomerCreated, dataChanged]);
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsx(Col, {
        lg: 10,
        md: 11,
        children: /*#__PURE__*/_jsx(Tabs, {
          items: items,
          animated: true
        })
      })
    }), /*#__PURE__*/_jsx(Modal, {
      title: "Infos patient",
      destroyOnClose: true,
      footer: null,
      visible: isPatientModalOpen,
      onCancel: function onCancel() {
        setIsPatientModalOpen(false);
      },
      children: /*#__PURE__*/_jsx(PatientView, {
        pid: searchId
      })
    }), currentCustomer != null && /*#__PURE__*/_jsx(Modal, {
      title: /*#__PURE__*/_jsxs("b", {
        children: ["MODIFICATION DU PATIENT - ", currentCustomer.name]
      }),
      destroyOnClose: true,
      width: "850px",
      footer: null,
      open: showEdit,
      onCancel: function onCancel() {
        setShowEdit(false);
      },
      children: /*#__PURE__*/_jsx(EditCandidate, {
        candidate: currentCustomer,
        handleUpdate: function handleUpdate() {
          setShowEdit(false);
          setDataChanged(true);
          notification.success({
            message: "Ok!",
            description: "Opération éffectuée"
          });
        }
      })
    })]
  });
};

export default Cashier;